import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { Bean, FormContextValues } from '@dreryk/react-common';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { useDiseaseDefaultItems } from './DiagnosesWithBodySideInteractiveTable.hooks';

type DiagnosesWithBodySideInteractiveTableProps = {
   readonly register: FormContextValues<Bean>['register'];
   readonly dictionaryValidOn: Date;
   readonly visitDiagnoses?: VisitDiagnosis[];
   readonly required?: boolean;
};

export const DiagnosesWithBodySideInteractiveTable = (
   props: DiagnosesWithBodySideInteractiveTableProps
): JSX.Element => {
   return (
      <diagnosesWithBodySideFormPart.InteractiveTable
         name={'diagnoses.value'}
         register={props.register}
         header={
            <diagnosesWithBodySideFormPart.InteractiveTable.Selector
               name={'diagnoses.selection'}
               register={props.register}
               dictionaryValidOn={props.dictionaryValidOn}
               defaultItems={useDiseaseDefaultItems(props.visitDiagnoses)}
               required={props.required}
            />
         }
      />
   );
};
